// zero-degree-guard.js
// Requires: evr-guard-utils.js loaded beforehand (window.EVR.GuardUtils)

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    if (!body || !body.classList.contains("zero-degree-guard")) return;

    const U = window.EVR && window.EVR.GuardUtils;
    if (!U) {
      console.error("[zero-degree-guard] Missing EVR.GuardUtils (evr-guard-utils.js not loaded?)");
      return;
    }

    const main = document.querySelector("main") || document.querySelector("#MainContent");
    if (main) main.style.visibility = "hidden";

    const overlay = U.createThemeOverlay({ initialText: "Zugriff wird geprüft …" });
    const setText = (t) => overlay.setText(t);
    const setHtml = (h) => overlay.setHtml(h);

    (async function runGuard() {
      try {
        // 1) Resolve env + autologin (shared)
        const env = U.resolveEnvFromUrlAndStorage();
        await U.autoLoginFromUrlIfPresent(env);

        // 2) Ensure Firebase user
        setText("Anmeldung wird geprüft …");
        const user = await U.ensureFirebaseUser(env, 5000);
        if (!user) {
          if (main) main.style.visibility = "visible";
          setHtml(
            '<div class="evr-odg__title">Anmeldung erforderlich</div>' +
              '<div class="evr-odg__text">Bitte öffne diesen Link direkt aus der EVERSION-App.</div>' +
              '<a class="evr-odg__link" href="/">Zur Startseite</a>'
          );
          return;
        }

        // 3) Require clusterId
        const clusterId = U.getClusterIdFromUrl();
        if (!clusterId) {
          setHtml(
            '<div class="evr-odg__title">Fehler: Messungs-Link ungültig</div>' +
              '<div class="evr-odg__text">' +
              "Für die Bestellung deiner individuellen 0°-Sohle benötigen wir die Messungs-ID (clusterId). " +
              "Bitte öffne den Bestell-Link direkt aus der EVERSION-App oder kontaktiere unseren Support." +
              "</div>" +
              '<a class="evr-odg__link" href="/">Zur Startseite</a>'
          );
          return;
        }

        // 4) Stable trackingId (domain-specific)
        const trackingId = getOrCreateZeroDegreeTrackingId();

        // 5) Prepare cart (domain-specific ensure-one-item)
        setText("Dein Warenkorb wird vorbereitet …");
        const { ok: cartOk, cartToken } = await ensureZeroDegreeInsoleInCart({
          clusterId,
          firebaseUserId: user.uid,
          env,
          trackingId,
        });

        if (!cartOk) {
          console.error("[zero-degree-guard] Failed to prepare cart for zero-degree insole.");
          setText("Es gab ein Problem beim Vorbereiten deines Warenkorbs. Bitte lade die Seite neu.");
          if (main) main.style.visibility = "visible";
          return;
        }

        // 5b) Persist fallback metadata into cart attributes (survives permalink cart rebuilds)
        // Use shared merge (works like your old ensureCartAttributesContainTrackingId but simpler)
        await U.mergeCartAttributes({
          evr_odg_tracking_id: String(trackingId),
          evr_odg_cluster_id: String(clusterId),
          evr_odg_env: String(env),
          evr_uid: String(user.uid || ""),
          evr_cart_token: String(cartToken || ""),
        });

        // 6) Persist DB-backed metadata (domain-specific)
        setText("Bestellinformationen werden vorbereitet …");
        const firebaseIdToken = await U.getFirebaseIdTokenOrNull(user);
        if (!firebaseIdToken) {
          if (main) main.style.visibility = "visible";
          setHtml(
            '<div class="evr-odg__title">Anmeldung fehlgeschlagen</div>' +
              '<div class="evr-odg__text">Bitte öffne den Link erneut aus der EVERSION-App.</div>' +
              '<a class="evr-odg__link" href="/">Zur Startseite</a>'
          );
          return;
        }

        const coupon = U.getCouponFromUrl();
        const hasCoupon = !!coupon;

        try {
          await registerZeroDegreeDraftOrder({
            trackingId,
            cartId: cartToken || "",
            email: user.email,
            clusterId,
            hasCoupon,
            env,
            firebaseIdToken,
          });
        } catch (e) {
          console.error("[zero-degree-guard] registerZeroDegreeDraftOrder failed:", e);
          // continue - checkout can still proceed; webhook fallback via attributes exists
        }

        // 7) Checkout prefill (shared). If it fails, log why and fall back to /checkout.
        setText("Bestelldaten werden vorbereitet …");
        let prefill = null;
        try {
          prefill = await U.fetchCheckoutPrefill({ firebaseIdToken });
        } catch (e) {
          console.warn("[zero-degree-guard] fetchCheckoutPrefill threw:", e);
        }

        setText("Weiterleitung zur Kasse …");
        const origin = window.location.origin;
        console.log("[zero-degree-guard] prefill:",prefill);
        if (prefill) {
          const checkoutUrl = U.buildCheckoutPrefillUrl({ origin, prefill });
          console.log("checkoutUrl",checkoutUrl);

          // IMPORTANT: use shared helper; it handles /discount redirect=pathname+search correctly
          U.redirectToCheckoutWithOptionalCoupon({ checkoutUrl, coupon });
          return;
        }

        // Fallback: still apply coupon if present
        if (coupon) {
          window.location.href = `${origin}/discount/${encodeURIComponent(String(coupon).trim())}?redirect=/checkout`;
          return;
        }

        window.location.href = "/checkout";
      } catch (err) {
        console.error("[zero-degree-guard] Fatal error:", err);
        if (main) main.style.visibility = "visible";
        try {
          overlay.destroy();
        } catch (_) {}
        // TEMP DEBUG: Redirect auf Root deaktiviert, damit man bei Fehlern auf der Seite bleibt.
        // window.location.href = "/";
      }
    })();

    // -------------------------------------------------------------------------
    // Domain-specific helpers (from your original code, formatted + kept intact)
    // -------------------------------------------------------------------------

    /**
     * Stable trackingId stored in localStorage (permalink-proof).
     */
    function getOrCreateZeroDegreeTrackingId() {
      const KEY = "evr_odg_tracking_id";
      try {
        const existing = localStorage.getItem(KEY);
        if (existing && existing.trim()) return existing.trim();

        const id =
          "evr-odg-" +
          Date.now().toString(36) +
          "-" +
          Math.random().toString(36).slice(2, 10);

        localStorage.setItem(KEY, id);
        return id;
      } catch (e) {
        // Fallback: still generate deterministic-ish id (won't survive storage errors)
        return "evr-odg-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
      }
    }

    /**
     * Ensure cart contains exactly ONE line item: zero-degree variant, qty=1.
     * Returns { ok, cartToken } where cartToken is Shopify cart token (if obtainable).
     *
     * NOTE:
     * - Line item properties are best-effort; Shopify permalink /cart/{variant}:1 URLs can recreate cart lines.
     * - Therefore we rely on DB + cart.attributes for persistence.
     */
    async function ensureZeroDegreeInsoleInCart(meta) {
      meta = meta || {};

      const clusterId = meta.clusterId || null;
      const firebaseUserId = meta.firebaseUserId || null;
      const env = (meta.env || "prod").toLowerCase();
      const trackingId = meta.trackingId || null;

      const variantId = getZeroDegreeVariantIdFromPageOrUrl();
      if (!variantId) return { ok: false, cartToken: null };

      let cartToken = null;

      try {
        const cartRes = await fetch("/cart.js", {
          method: "GET",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });

        if (cartRes.ok) {
          const cartData = await cartRes.json();
          cartToken = cartData.token || null;

          const items = cartData.items || cartData.line_items || [];
          const firstItem = items[0] || {};
          const firstProps = firstItem.properties || {};
          // The line item must not only be the right variant/qty — its
          // _evr_cluster_id (and firebase user) must match the CURRENT selection.
          // A cart reused from an earlier measurement can still hold the correct
          // variant with a STALE _evr_cluster_id; returning early there would ship
          // the old cluster to the ERP (see repeat-order incident #2555). If the
          // binding differs we fall through and rebuild the cart line below.
          const clusterMatches = String(firstProps._evr_cluster_id || "") === String(clusterId || "");
          const userMatches =
            !firebaseUserId || String(firstProps._evr_firebase_user_id || "") === String(firebaseUserId);
          const hasOnlyOneCorrectItem =
            items.length === 1 &&
            String(firstItem.variant_id || firstItem.id) === String(variantId) &&
            firstItem.quantity === 1 &&
            clusterMatches &&
            userMatches;

          if (hasOnlyOneCorrectItem) {
            console.log("[zero-degree-guard] Cart already has correct single zero-degree item with matching cluster.");
            return { ok: true, cartToken };
          }

          if (
            items.length === 1 &&
            String(firstItem.variant_id || firstItem.id) === String(variantId) &&
            !clusterMatches
          ) {
            console.log(
              "[zero-degree-guard] Rebuilding cart: line item _evr_cluster_id (" +
                String(firstProps._evr_cluster_id || "") +
                ") != current clusterId (" +
                String(clusterId || "") +
                ")."
            );
          }
        }

        // Clear and re-add with properties (best-effort)
        await fetch("/cart/clear.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
        });

        const addBody = { id: variantId, quantity: 1 };
        const props = {};

        if (clusterId) props._evr_cluster_id = clusterId;
        if (firebaseUserId) props._evr_firebase_user_id = firebaseUserId;
        if (trackingId) props._evr_odg_tracking_id = trackingId;

        props._evr_zero_env = env;
        addBody.properties = props;

        const addRes = await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(addBody),
        });

        if (!addRes.ok) {
          console.error("[zero-degree-guard] /cart/add.js failed:", addRes.status, await addRes.text());
          return { ok: false, cartToken: null };
        }

        // Fetch cart again to get cart token
        try {
          const cartRes2 = await fetch("/cart.js", {
            method: "GET",
            credentials: "same-origin",
            headers: { Accept: "application/json" },
          });

          if (cartRes2.ok) {
            const cartData2 = await cartRes2.json();
            cartToken = cartData2.token || cartToken;
          }
        } catch (_) {}

        return { ok: true, cartToken };
      } catch (err) {
        console.error("[zero-degree-guard] ensureZeroDegreeInsoleInCart error:", err);
        return { ok: false, cartToken: null };
      }
    }

    /**
     * DB-backed metadata persist (App Proxy).
     *
     * Body includes trackingId (REQUIRED by your updated backend).
     */
    async function registerZeroDegreeDraftOrder({
      trackingId,
      cartId,
      email,
      clusterId,
      hasCoupon,
      env,
      firebaseIdToken,
    }) {
      if (!trackingId || !clusterId) {
        console.warn("[zero-degree-guard] registerZeroDegreeDraftOrder: missing trackingId/clusterId, skipping.");
        return;
      }
      if (!firebaseIdToken) {
        console.warn("[zero-degree-guard] registerZeroDegreeDraftOrder: missing firebaseIdToken, skipping.");
        return;
      }

      const ZERO_DEGREE_DRAFT_ENDPOINT =
        window.EVR && window.EVR.zeroDegreeDraftEndpoint
          ? window.EVR.zeroDegreeDraftEndpoint
          : "/apps/eversion-backend/api/zero-degree-draft-order";

      const payload = {
        trackingId,
        clusterId,
        env: env || "prod",
        hasCoupon: !!hasCoupon,
        email: email || "",
        cartId: cartId || "", // optional
      };

      const res = await fetch(ZERO_DEGREE_DRAFT_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${firebaseIdToken}`,
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
        credentials: "include",
      });

      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        console.warn("[zero-degree-guard] registerZeroDegreeDraftOrder failed:", res.status, txt);
        return;
      }

      const data = await res.json().catch(() => ({}));
      console.log("[zero-degree-guard] registerZeroDegreeDraftOrder OK:", data);
    }

    /**
     * Find the zero-degree variant id from:
     * 1) product form input[name="id"]
     * 2) ?variant=... URL param
     */
    function getZeroDegreeVariantIdFromPageOrUrl() {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.value) return idInput.value;
      }

      try {
        const url = new URL(window.location.href);
        const v = url.searchParams.get("variant");
        if (v) return v;
      } catch (e) {
        console.warn("[zero-degree-guard] getZeroDegreeVariantIdFromPageOrUrl: URL parse failed:", e);
      }

      console.error("[zero-degree-guard] Could not determine zero-degree variant ID from page or URL.");
      return null;
    }

    /**
     * (Kept for parity with your original guard)
     * If you still want the old explicit attribute merge call anywhere, keep this.
     * In this full script we already use U.mergeCartAttributes() instead.
     */
    async function ensureCartAttributesContainTrackingId({ trackingId, clusterId, env }) {
      if (!trackingId) return;

      let cart = null;
      try {
        const res = await fetch("/cart.js", {
          method: "GET",
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        if (res.ok) cart = await res.json();
      } catch (_) {}

      const existing = (cart && cart.attributes) || {};
      const merged = {};

      try {
        for (const k in existing) {
          if (Object.prototype.hasOwnProperty.call(existing, k)) merged[k] = existing[k];
        }
      } catch (_) {}

      merged.evr_odg_tracking_id = String(trackingId);
      if (clusterId) merged.evr_odg_cluster_id = String(clusterId);
      if (env) merged.evr_odg_env = String(env);

      try {
        await fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: merged }),
        });
      } catch (e) {
        console.warn("[zero-degree-guard] ensureCartAttributesContainTrackingId failed:", e);
      }
    }
  });
})();